import { CMSLink, MediaImage, Typography } from '~/shared/components';
import styles from './promoted-item.module.css';
import { PromotedNavigationNode } from '~/lib/data-contract';
import { getObjectPosition } from '~/shared/utils/umbraco/get-object-position';
import { queries } from '~/theme';

type Props = {
    item: PromotedNavigationNode;
    onNavigationClick?: () => void;
};

const PromotedItem = ({ item, onNavigationClick }: Props) => {
    const objectPosition = getObjectPosition(item.image?.focalPoint);

    return (
        <CMSLink className={styles.root} href={item.link?.url || ''} onClick={onNavigationClick}>
            <MediaImage
                src={item.image?.src || ''}
                alt={item.image?.alt || ''}
                style={{ objectFit: 'cover', objectPosition }}
                height={800}
                width={800}
                sizes={`(${queries.md}) 50vw, 30vw`}
                dimensions={item.image?.dimensions}
                name={item.image?.name}
            />
            <Typography variant="body1" as="p" className={styles.text}>
                {item.text}
            </Typography>
        </CMSLink>
    );
};

export default PromotedItem;
